<script setup lang="ts">
import styles from '@/assets/sass/components/search-menu.module.scss';
import DestinationFilter from '@/components/DestinationFilter.vue';
</script>
<template>
    <div :class="styles.container">
        <div :class="styles.filters">
            <div :class="styles.filter">
                <DestinationFilter />
            </div>
            <div :class="styles.filter">
                datum
            </div>
            <div :class="styles.filter">
                posádka
            </div>
            <div :class="styles.filter">
                plavební společnost
            </div>
            <div :class="styles.search">
                vyhledat zájezdy
            </div>
        </div>
        <div :class="styles.toggles">
            <div :class="styles.types">
                <div :class="styles.type">
                    s letenkou
                </div>
                <div :class="styles.type">
                    s delegátem
                </div>
                <div :class="styles.type">
                    Luxusní plavby
                </div>
                <div :class="styles.type">
                    Akční plavby
                </div>
            </div>
            <div :class="styles.advanced">
                Pokročilé vyhledávání
            </div>
        </div>
    </div>
</template>
